var ShippingNote = {
  inited: false,
  currentSelection: null,
  methodDiv: null,
  init: function(retry){
    ShippingNote.methodDiv = $("fieldset[data-shipping-methods]");
    
    $(document).on("click","fieldset[data-shipping-methods] input",ShippingNote.update);
    
    if(ShippingNote.methodDiv && ShippingNote.methodDiv.find('input').length > 0){
      ShippingNote.inited = true;
    }else{
      setTimeout(function(){ 
      							ShippingNote.init.apply(ShippingNote,[1]);
      						},100);
    }
    if(ShippingNote.inited && retry) ShippingNote.run(retry);
    return ShippingNote.inited;
  },
  run: function(retry){
    
    var ready = false;
    if(!ShippingNote.inited) ready = ShippingNote.init();
    
    if(!ready && !retry) return;
    
    ShippingNote.methodDiv.find('input:checked').trigger('click');
    setInterval(function(){ ShippingNote.methodDiv.find('input:checked').trigger('click'); }, 5000);
  },
  update: function(){
      var selected = ShippingNote.methodDiv.find(":checked");        
      var selectedId = selected.attr('id');
    
      if(selected && selectedId != ShippingNote.currentSelection){
        
        var promisedDate2 = $.trim($("form[data-shipping-method-form] input:checked").closest('.radio__input').next('.radio__label').find('.small-text').text()).split(",")[1];
        var dateParts = promisedDate2.split(" ");
        if((thisMonth == 'Nov' || thisMonth == 'Dec') && dateParts[0] != 'Nov' && dateParts[0] != 'Dec'){
            promisedDate2 += ", "+String((parseInt(thisYear)+1));
        }else{
            promisedDate2 += ", "+parseInt(thisYear);
        }
    
        
        promisedDate2 = $.trim(promisedDate2);
        if(!promisedDate2) promisedDate2 = '';
        
        
        var theForm = $("form[data-shipping-method-form]");
        var shippingIdField = theForm.find('input[name="checkout[attributes][shipping_id]"]');
        var promisedDateField = theForm.find('input[name="checkout[attributes][promised_date]"]');
        
        if(shippingIdField.length > 0){
          console.log("update field");
          shippingIdField.val(selectedId);
          promisedDateField.val(promisedDate2);
        }else{
          console.log("create field");
          theForm.append('<input type="hidden" name="checkout[attributes][shipping_id]" value="'+selectedId+'" data-_extension-text-contrast="">');
          theForm.append('<input type="hidden" name="checkout[attributes][promised_date]" value="'+promisedDate2+'" data-_extension-text-contrast="">');
          
        }
                                      
      	ShippingNote.currentSelection = selectedId;
      }
  }
  
  
};


TbmbmCart = {
  updateUrl: '',
  emptyUrl: '',
  checkoutUrl: '',
  total_amount: 0,
  total_items: 0,
  items: [],
  qtyChanged: false,
  init: function(){
    if(!window.tbmbmCustId) return;
    
  	this.loadCart(); 	
    jQuery('#cart-update').click(function(){
      jQuery('#cart-form').attr('action',TbmbmCart.updateUrl);
    });
    jQuery('#cart-checkout, #cart-checkout-2').click(function(){
      if(!TbmbmCart.checkQty()){
        alert('Please adjust item quantity!');
        return false;
      }
      if(TbmbmCart.total_amount<100 || TbmbmCart.qtyChanged)
      	jQuery('#cart-form').attr('action',TbmbmCart.updateUrl);  
      else
      	jQuery('#cart-form').attr('action',TbmbmCart.checkoutUrl);
      jQuery('#cart-checkout, #cart-checkout-2').attr('disabled');
    });
    
    jQuery("#cart-form").submit(TbmbmCart.submitCheck);
    
    // bind add to cart
    this.bindAddToCart();
  },
  
  checkQty: function(){
    var allgood = true;
    jQuery('#cart-form .cart__qty-input').each(function(){
      if(jQuery(this).val() > jQuery(this).data('wehave')){
        jQuery(this).next('.stock-warning').removeClass('hidden');
        allgood = false;
      }else{
        jQuery(this).next('.stock-warning').addClass('hidden');
      }
    });
    return allgood;
  },
  
  bindAddToCart: function(){
    
    // CollectionPage and product page
    $( document ).on( "submit", "form.product-form, form.product_form", function(e) {
      	var f = $(this);
        var q = $(this).find("input[name='quantity']").val();
      	var vEle = $(this).find(":input[name='id']");
      	var v = '';
      	console.log( vEle.prop("type"));
      	if(vEle.prop("tagName") == 'SELECT' || (vEle.prop("tagName") == 'INPUT' && vEle.prop("type") != 'radio')){
        	v = vEle.val();
        }else{
          v = $(this).find(":input[name='id']:checked").val();
        }
      	
        var shop = '{{ shop.domain }}';
        if(!window.tbmbmCustId) return;
        var postUrl = 'https://ws-apps.pinkcherrywholesale.ca/cart/add?custId='+window.tbmbmCustId+'&id='+v+'&quantity='+q+'&store=pinkcherrywholesale.ca';    
      	f.find('.addToCart, #add-to-cart').text('Adding..');
        jQuery.get(postUrl, function(data){
          if(data.status == -1){
            f.find('.addToCart, #add-to-cart').text('Add to cart');
            alert("Congratulations your cart is full.\n\nPlease checkout and then start a new order. ");
          }else{
            f.find('.addToCart, #add-to-cart').text('Thank you!');
          	setTimeout(function(){
          		f.find('.addToCart, #add-to-cart').text('Add to cart');
          	}, 1500);
          	jQuery('.ajaxified-cart-feedback').remove();
          	f.after('<p class="ajaxified-cart-feedback success" style="color: #3D9970;display: block;line-height: 36px;font-size: 90%;vertical-align: middle;text-transform: none;"><i class="fa fa-check"></i> Added to cart! <a href="/pages/cart">View cart</a></p>');
            
          	// collection page
          	//if(f.hasClass('product-form')){
          		TbmbmCart.loadCart();
        	//}else{ // product page
              	//window.location.href = '/pages/cart';
            //}
            
            
           
          }
        });
      	return false;
      });
    
    
    
    /* klaviyo tracking start */
    $(document).on('click', ".add-to-cart-collection", function(){
      	_learnq.push(['track', 'Added to Cart', window['item_'+$(this).closest('form').data('pid')]]);  
    });
    /* klaviyo tracking end */
    
    
    
  },
  loadCart: function(){
    var url = 'https://ws-apps.pinkcherrywholesale.ca/cart/cart?custId='+window.tbmbmCustId+'&store=pinkcherrywholesale.ca';
    if(window.tmbmbCartPage){
      url += "&inventoryCheck=1";
    }
    
    jQuery.get(url, function(data,status){
      TbmbmCart.updateUrl = data.update_link.replace('tbmbm-ws.herokuapp.com', 'ws-apps.pinkcherrywholesale.ca')+'&store=pinkcherrywholesale.ca';
      TbmbmCart.checkoutUrl = data.checkout_link.replace('tbmbm-ws.herokuapp.com', 'ws-apps.pinkcherrywholesale.ca')+'&store=pinkcherrywholesale.ca';
      TbmbmCart.total_amount = parseFloat(Math.round(data.cartTotals.total_amount * 100) / 100).toFixed(2);
      TbmbmCart.total_items = data.cartTotals.total_items;
      TbmbmCart.items = data.cartItems;
      TbmbmCart.updateTopRight();
      
      if(window.tmbmbCartPage){
        jQuery('#cart-loading').addClass('hidden');
        jQuery('#cart-form').attr('action',TbmbmCart.updateUrl);
        if(data.cartItems.length == 0){
        	jQuery(".empty-page-content").removeClass('hidden');  
        }else{

          var itemTemplate = Handlebars.compile(jQuery("#item-template").html());
          var cartRowsHtml = '';
          for(var i=0; i<data.cartItems.length; i++){
            var itemData = data.cartItems[i];        
            itemData.price = parseFloat(Math.round(itemData.price * 100) / 100).toFixed(2);
            itemData.regular_price = parseFloat(Math.round(itemData.regular_price * 100) / 100).toFixed(2);
            itemData.line_total = parseFloat(Math.round(itemData.line_total * 100) / 100).toFixed(2);
            itemData.isPlatinum = data.custType=='platinum';
            itemData.good_stock = (itemData.quantity <= itemData.max_inventory ? true : false); 
            itemData.remove_link = itemData.remove_link.replace('tbmbm-ws.herokuapp.com', 'ws-apps.pinkcherrywholesale.ca');
            itemData.tiered = 0;
            if(data.discountType == 1250) itemData.tiered = 2;
            if(data.discountType == 2500) itemData.tiered = 5;
            if(data.discountType == 10000) itemData.tiered = 7;
            
             
            cartRowsHtml += itemTemplate(itemData);
          }
          var showingAwayBlocks = [];
          console.log(showingAwayBlocks)
          jQuery("#shopping-cart-table tbody").html(cartRowsHtml);
          jQuery("#cart_subtotal").text("$"+TbmbmCart.total_amount);
          if(data.cartTotals.total_amount >= 100){
           	jQuery('#minimum-message').hide(); 
            jQuery('.total-not-met-button').hide(); 
          }
          if(data.cartTotals.total_amount < 500){
            jQuery('#got-free-shipping').addClass('hidden');
            jQuery('#got-free-shipping').hide();
            jQuery('#still-need-amount').text(parseFloat(500 - Math.round(data.cartTotals.total_amount * 100) / 100).toFixed(2));
            jQuery('#got-no-free-shipping').removeClass('hidden');
            jQuery('#tiered_1').addClass('no-free-shipping');
            jQuery('#tiered_2').addClass('no-free-shipping');
            jQuery('#tiered_3').addClass('no-free-shipping');
            //showingAwayBlocks.push('#got-no-free-shipping');
          }else{
            jQuery('#got-free-shipping').removeClass('hidden');
            jQuery('#got-no-free-shipping').addClass('hidden');
            jQuery('#tiered_1').removeClass('no-free-shipping');
            jQuery('#tiered_2').removeClass('no-free-shipping');
            jQuery('#tiered_3').removeClass('no-free-shipping');
            jQuery('#got-no-free-shipping').hide();
            //showingAwayBlocks.push('#got-free-shipping');
          }
          
          console.log(showingAwayBlocks)
          
          // off perct away blocks
          for (var tieredIdx in data.tieredInfo) {
            var idd = data.tieredInfo[tieredIdx].id;
            if(data.tieredInfo[tieredIdx].reach > 0){
             	jQuery('#tiered_'+ idd).removeClass('hidden');
              	jQuery('#still-need-amount-tiered-'+idd).text((Math.round(data.tieredInfo[tieredIdx].reach * 100) / 100).toFixed(2));
              	showingAwayBlocks.push('#tiered_'+ idd);
            }else{
             	jQuery('#tiered_'+ idd).hide(); 
            }
              
          }
          console.log(showingAwayBlocks)
          
          jQuery('#tiered_1').css('width','33%');
          jQuery('#tiered_2').css('width','33%');
            jQuery('#tiered_3').css('width','33%');

          
          if(jQuery.inArray('#tiered_1',showingAwayBlocks) == -1 && jQuery.inArray('#tiered_1_done',showingAwayBlocks) == -1){ // 5% is not displaying, then show Congrats on 5%
           	 showingAwayBlocks.push('#tiered_1_done');
             jQuery('#tiered_1_done').removeClass('hidden').show();
            
            
            jQuery('#tiered_2').css('width','49.5%');
            jQuery('#tiered_3').css('width','49.5%');
            
            jQuery('#2Reached').removeClass('hidden').show();
            
            jQuery('#tiered_2').addClass("tier2");
            jQuery('#tiered_3').addClass("tier2");
            jQuery('#tiered_1_done').remove();
            jQuery('#tiered_1').remove();
            //console.log("Tier1");
          }
          
          if(jQuery.inArray('#tiered_2',showingAwayBlocks) == -1){ // 7% displaying, then show Congrats on 7%
          	 showingAwayBlocks.push('#tiered_2_done');
             jQuery('#tiered_2_done').removeClass('hidden').show();
            
            
            jQuery('#2Reached').toggle();
            jQuery('#5Reached').removeClass('hidden').show();
            
            
            jQuery('#tiered_3').css('width','100%');
             jQuery('#tiered_2_done').remove();
            jQuery('#tiered_1_done').remove();
            
            jQuery('#tiered_2').remove();
            jQuery('#tiered_1').remove();
            console.log("Tier2");
          }
          
          
          if(jQuery.inArray('#tiered_3',showingAwayBlocks) == -1 && jQuery.inArray('#tiered_3_done',showingAwayBlocks) == -1){ // 7% is not displaying, then show Congrats on 5%
           	 showingAwayBlocks.push('#tiered_3_done');
             jQuery('#tiered_3_done').removeClass('hidden').show();
            jQuery('#tiered_3_done').css('width','100%');
            jQuery('#2Reached').remove();
            jQuery('#5Reached').remove();
            console.log("Tier3");
          }
		  
          var awayBlockWidth = 100;
          if(showingAwayBlocks.length == 2) awayBlockWidth = 100;
          if(showingAwayBlocks.length == 3) awayBlockWidth = 100;
          if(showingAwayBlocks.length == 4) awayBlockWidth = 100;
          jQuery(showingAwayBlocks.join(",")).css('display','inline-block');
         
          
          
          if(data.cartTotals.total_amount >= 100){
            jQuery("#cart-checkout-2, #cart-checkout").show();
          }
          
          jQuery('#cart-content').removeClass('hidden');
        }
        
        jQuery('#cart-form .cart__qty-input').change(function(){
          	TbmbmCart.qtyChanged = true;
        });
      }
    });
  },
  updateTopRight: function(){
    jQuery('.cart_num').text(TbmbmCart.total_items);
    jQuery(".line_item_number").text(TbmbmCart.items.length);
  },
  checkOutPageInit: function(){
     setInterval(TbmbmCart.checkoutShippingCheck, 100);
    setInterval(TbmbmCart.checkoutPaymentCheck, 300);
    ShippingNote.run.call(ShippingNote);
    
  },
  checkoutShippingCheck: function(){
    return;
    var subtotal = parseInt($('.total-line-table [data-checkout-subtotal-price-target]').data('checkout-subtotal-price-target'));
    var defaultChecked = false;
    //console.log(subtotal);
    jQuery(".section--shipping-method .radio__input input").each(function(){
      	if(jQuery(this).attr('id').indexOf('_free-') != -1){
          if(subtotal < 50000){ 
            jQuery(this).closest('.content-box__row').remove();
          }else{
            jQuery(this).closest('.content-box__row').show();
            defaultChecked = jQuery(this).is(":checked");
          }
        }else{
          if(subtotal < 50000){ 
            jQuery(this).closest('.content-box__row').show();
            defaultChecked = jQuery(this).is(":checked");
          }else{
            jQuery(this).closest('.content-box__row').remove();
          }
        }
    });
    if(!defaultChecked){  // no shipping checked, select the first one
      jQuery(".section--shipping-method .radio__input input:first").trigger('click');
    }
    
  },
  checkoutPaymentCheck: function(){
    if(window.customerTags.indexOf('CreditCardOnFile') == -1){
      jQuery(".section--payment-method .radio__label__primary").each(function(){
        if(jQuery.trim(jQuery(this).text()) == 'Credit Card on File'){
         	jQuery(this).closest('.radio-wrapper').remove();
        }
      });
    }
  }
};